export default function Pagination(){
    return {
        defaultProps: {
            color: "primary",
            size: "medium"
        }
    }
}